import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {
    fade,
    Paper,
} from '@material-ui/core';
import {
    ToggleButton,
    ToggleButtonGroup,
} from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    root: {},
    toggleContainer: {},
    toggleButtonGroup: {
        width: '100%',
    },
    selected: {
        backgroundColor: fade(theme.palette.primary.dark, 0.12),
    },
    disabled: {
        color: fade(theme.palette.action.disabled, 0.12),
    },
    toggleButton: {
        flexGrow: 1,
        ...theme.typography.button,
        boxSizing: 'border-box',
        borderRadius: theme.shape.borderRadius,
        height: 48,
        padding: '0px 12px',
        border: `1px solid ${fade(theme.palette.primary.dark, 0.12)}`,
        color: fade(theme.palette.text.primary, 1),
        '&$selected': {
            color: theme.palette.primary.dark,
            backgroundColor: fade(theme.palette.primary.dark, 0.12),
            '&:hover': {
                backgroundColor: fade(theme.palette.primary.dark, 0.15),
            },
            '& + &': {
                borderLeft: 0,
                marginLeft: 0,
            },
        },
        '&$disabled': {
            color: fade(theme.palette.action.disabled, 0.12),
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: fade(theme.palette.primary.dark, 0.05),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
            '&$disabled': {
                backgroundColor: 'transparent',
            },
        },
    },
}));

const ReportToggle = props => {
    const {className, term, onChange, ...rest} = props;
    const classes = useStyles(props);
    const [report, setReport] = React.useState('dashboard');
    const handleReport = (event, newReport) => {
        setReport(newReport);
        onChange(newReport);
    };
    const termLabel = {
        'daily': 'Daily',
        'weekly': 'Weekly',
        'monthly': 'Monthly',
    };

    return (
        <Paper
            {...rest}
            className={clsx(classes.root, className)}
            elevation={1}
        >
            <ToggleButtonGroup
                className={classes.toggleButtonGroup}
                exclusive
                onChange={handleReport}
                value={report}
            >
                <ToggleButton
                    classes={{
                        root: classes.toggleButton,
                        selected: classes.selected,
                        disabled: classes.disabled,
                    }}
                    value="dashboard"
                >
                    {termLabel[term]} Dashboard
                </ToggleButton>

                <ToggleButton
                    classes={{
                        root: classes.toggleButton,
                        selected: classes.selected,
                        disabled: classes.disabled,
                    }}
                    value="performance"
                >
                    {termLabel[term]} comparison
                </ToggleButton>

                <ToggleButton
                    classes={{
                        root: classes.toggleButton,
                        selected: classes.selected,
                        disabled: classes.disabled,
                    }}
                    value="competition"
                >
                    {termLabel[term]} competition analysis
                </ToggleButton>
            </ToggleButtonGroup>
        </Paper>
    );
};

ReportToggle.propTypes = {
    className: PropTypes.string,
    term: PropTypes.string,
    onChange: PropTypes.func
};

export default ReportToggle;
